"use client";

import React from "react";
import { Cards } from "../../data/ecommerce-development";

const BRAND = "#F48428";

export default function EcomAIIntegration() {
  return (
    <section
      className="py-5 position-relative"
      style={{ background: "#0f0f0f", overflow: "hidden" }}
    >
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: "-20% -10% auto -10%",
          height: 420,
          background: `radial-gradient(600px 220px at 50% 50%, ${BRAND}22, transparent 60%)`,
        }}
      />

      <div className="container">
        <div className="text-center mb-4" data-reveal="fade">
          <div
            className="text-uppercase small"
            style={{ color: BRAND, letterSpacing: ".18em" }}
          >
            AI Integration in E‑Commerce
          </div>
          <h2 className="fw-bold text-white mt-1">
            Seamless AI Integration for Advanced E‑commerce
          </h2>
          <p
            className="text-secondary m-0"
            style={{ maxWidth: 900, margin: "0 auto" }}
          >
            Embed intelligent AI capabilities directly into your e‑commerce
            platform. Elevate customer interaction, streamline operations, and
            drive growth through enhanced digital commerce solutions.
          </p>
        </div>

        <div className="row g-3" data-reveal="stagger-mix">
          {Cards.map(({ icon, title, text }) => (
            <div key={title} className="col-12 col-md-6 col-lg-3">
              <div
                className="h-100 p-4"
                style={{
                  background: "linear-gradient(180deg, #141414, #121212)",
                  borderRadius: 16,
                  border: "1px solid rgba(255,255,255,0.12)",
                  boxShadow: "0 10px 22px rgba(0,0,0,0.35)",
                  transition:
                    "transform .25s cubic-bezier(.2,.7,.3,1), box-shadow .25s, border-color .25s, background .25s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.borderColor = `${BRAND}44`;
                  e.currentTarget.style.boxShadow =
                    "0 16px 28px rgba(0,0,0,0.45)";
                  e.currentTarget.style.background =
                    "linear-gradient(180deg, #161616, #131313)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.12)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(0,0,0,0.35)";
                  e.currentTarget.style.background =
                    "linear-gradient(180deg, #141414, #121212)";
                }}
              >
                <div
                  className="d-inline-flex align-items-center justify-content-center mb-3"
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 16,
                    background: `${BRAND}22`,
                    color: BRAND,
                    border: `1px solid ${BRAND}55`,
                    boxShadow: `0 0 0 6px ${BRAND}11`,
                  }}
                >
                  <i className={icon}></i>
                </div>
                <h3 className="h5 text-white mb-2" style={{ lineHeight: 1.25 }}>
                  {title}
                </h3>
                <p className="text-secondary m-0">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
